export const PLYR_CONTROLS = {
  play: 'play',
  progress: 'progress',
  currentTime: 'current-time',
  mute: 'mute',
  volume: 'volume',
  fullscreen: 'fullscreen',
  captions: 'captions',
};

export const DEFAULT_CONTROLS = [PLYR_CONTROLS.play, PLYR_CONTROLS.progress, PLYR_CONTROLS.currentTime, PLYR_CONTROLS.mute, PLYR_CONTROLS.volume, PLYR_CONTROLS.fullscreen, PLYR_CONTROLS.captions].join(',');

export const CLASSES = {
  plyrVolume: 'plyr__volume',
  isVisible: 'is-visible',
  plyrControlActive: 'plyr__control--is-active',
};

export const YOUTUBE_REG_EX = /youtube/gim;
export const VIMEO_REG_EX = /vimeo/gim;
export const MP4_REG_EX = /\.mp4/gim;
export const WEBM_REG_EX = /\.webm/gim;
